export default "__VITE_ASSET__tKMAD45n__"